// Angular
import { NgModule } from '@angular/core';

// Afidium
import { BookingProcessingMenuService } from './booking-processing-menu.service';

@NgModule({
    providers: [
        BookingProcessingMenuService,
    ],
})
export class BookingProcessingMenuModule { }